import { Dispatch, SetStateAction, createContext } from 'react'

import { EditCreditNoteModalEnum } from '@/modules/invoices/types/EditCreditNoteModalEnum'
import { EditInvoiceModalEnum } from '@/modules/invoices/types/EditInvoiceModalEnum'
import { EditStatementModalEnum } from '@/modules/statements/types/EditStatementModalEnum'

export interface DetailsContextType {
  setModalType?: Dispatch<
    SetStateAction<string | EditInvoiceModalEnum | EditCreditNoteModalEnum | EditStatementModalEnum | null>
  >
  showUpdateButton?: boolean
  tooltip?: boolean
}

export const DetailsContext = createContext<null | DetailsContextType>(null)
